<template>
  <div class="row">
    <div class="small-12 columns course-content-editor-container">
      <div
        class="close-button absolute cursor-pointer"
        title="Close (Esc)"
        @click="$emit('CLOSE_MODAL')"
      >
        ❌
      </div>
      <div class="row">
        <div class="small-12 columns">
          <h3>{{ question.name }}</h3>
        </div>
        <div class="small-6 columns">is Required</div>
        <div class="small-6 columns">
          <input v-model="question.is_required" type="checkbox" />
        </div>
        <div class="small-6 columns">is Bonus</div>
        <div class="small-6 columns">
          <input v-model="question.is_bonus" type="checkbox" />
        </div>
        <div>
          <button
            class="button-blue py-2 px-4 rounded-sm mr-2"
            @click="updateQuestion"
          >
            Update Question
          </button>
          <button
            class="button-red py-2 px-4 rounded-sm"
            @click="deleteQuestion"
          >
            Unlink Question
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex"

export default {
  props: ["question"],
  data() {
    return {}
  },
  computed: {
    ...mapGetters("module", [
      "getCurrentEditingQuestion",
      "getCurrentEditingTopic",
    ]),
  },
  mounted() {},
  methods: {
    ...mapActions("module", ["LOAD_CURRENT_COURSES_EDITING_STATE"]),
    updateQuestion() {
      this.$emit("ELEMENT_UPDATED")
    },
    deleteQuestion() {
      this.$emit("QUESTION_DELETE", this.question.id, this.question.idx)
    },
  },
}
</script>
